import { StringSchema, yup } from '@framework/validation';
import { mapReferenceToPath } from '../../../../expressions/evaluate/mapReferenceToPath';
import { createEvaluationVariables } from '../../../../expressions/evaluate/variables/IEvaluationVariables';
import { OptionExpressionUtility } from '../common/option-list/validation/OptionExpressionUtility';
import { getOptionsPossibleValues } from '../common/util/getOneOfOptionSchema';
import { ISingleSelectWidget } from './ISingleSelectWidget';

export function getSingleSelectWidgetSchema(widget: ISingleSelectWidget) {
  const possibleOptions = getOptionsPossibleValues(widget.options);

  // Per ogni opzione, genero una coppia valore-espressione
  const expressions = OptionExpressionUtility.getPropertyExpression(
    'enabled',
    widget.options,
  );

  // Per ogni espressione, recupero le variabili utilizzate
  const references =
    OptionExpressionUtility.getExpressionsReferences(expressions);

  // Estraggo tutti i path utilizzati dalle variabili
  const paths = references.flatMap(r => mapReferenceToPath(r));

  return yup
    .string()
    .oneOf(possibleOptions)
    .parentWhen(paths, (values, schema: StringSchema, context: any) => {
      const variables = createEvaluationVariables(references, values);

      // Per ogni opzione, valuto se è editabile
      // se lo è la aggiungo alle opzioni valide e selezionabili
      const validOptions = widget.options
        .map(o => {
          // Se non è un'opzione, la ignoro
          if (o.type !== 'option') return null;
          // Calcolo l'editabilità dell'opzione
          const enabled = OptionExpressionUtility.getPropertyResult(
            'enabled',
            o,
            variables,
          );
          // Se l'editabilità è specificatamente falsa, ignoro il valore
          return enabled === false ? null : o.value;
        })
        .filter((o): o is string => o !== null);

      // Applico un transform che rimuove tutte le opzioni non editabili
      return schema.transform(value => {
        // Se il valore fosse null, torna null, così da non essere sovrascritto
        // Se il valore fosse undefined, verrebbe sostituito col default
        // Se il valore è definito, lo sostituisco solo se è tra le opzioni valide
        if (!value) {
          return value;
        }
        return validOptions.includes(value) ? value : null;
      });
    })
    .notRequired();
}
